function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRealEstate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.681,1.279C1.649,1.279 -0,2.928 -0,4.96L-0,36.866C-0,38.898 1.649,40.547 3.681,40.547L11.044,40.547L11.044,34.412C11.044,32.379 12.693,30.73 14.726,30.73C16.758,30.73 18.407,32.379 18.407,34.412L18.407,40.547L25.77,40.547C27.802,40.547 29.451,38.898 29.451,36.866L29.451,4.96C29.451,2.928 27.802,1.279 25.77,1.279L3.681,1.279ZM4.909,19.686C4.909,19.011 5.461,18.459 6.136,18.459L8.59,18.459C9.265,18.459 9.817,19.011 9.817,19.686L9.817,22.14C9.817,22.815 9.265,23.367 8.59,23.367L6.136,23.367C5.461,23.367 4.909,22.815 4.909,22.14L4.909,19.686ZM13.498,18.459L15.953,18.459C16.628,18.459 17.18,19.011 17.18,19.686L17.18,22.14C17.18,22.815 16.628,23.367 15.953,23.367L13.498,23.367C12.824,23.367 12.271,22.815 12.271,22.14L12.271,19.686C12.271,19.011 12.824,18.459 13.498,18.459ZM19.634,19.686C19.634,19.011 20.186,18.459 20.861,18.459L23.316,18.459C23.99,18.459 24.543,19.011 24.543,19.686L24.543,22.14C24.543,22.815 23.99,23.367 23.316,23.367L20.861,23.367C20.186,23.367 19.634,22.815 19.634,22.14L19.634,19.686ZM6.136,8.642L8.59,8.642C9.265,8.642 9.817,9.194 9.817,9.869L9.817,12.323C9.817,12.998 9.265,13.55 8.59,13.55L6.136,13.55C5.461,13.55 4.909,12.998 4.909,12.323L4.909,9.869C4.909,9.194 5.461,8.642 6.136,8.642ZM12.271,9.869C12.271,9.194 12.824,8.642 13.498,8.642L15.953,8.642C16.628,8.642 17.18,9.194 17.18,9.869L17.18,12.323C17.18,12.998 16.628,13.55 15.953,13.55L13.498,13.55C12.824,13.55 12.271,12.998 12.271,12.323L12.271,9.869ZM20.861,8.642L23.316,8.642C23.99,8.642 24.543,9.194 24.543,9.869L24.543,12.323C24.543,12.998 23.99,13.55 23.316,13.55L20.861,13.55C20.186,13.55 19.634,12.998 19.634,12.323L19.634,9.869C19.634,9.194 20.186,8.642 20.861,8.642Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRealEstate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/real-estate.5b1bf187c5ae2ddf6e4a9ecc36bb3f40.svg";